"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _style = _interopRequireDefault(require("./style.css"));
var _isNil2 = _interopRequireDefault(require("lodash/isNil"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/*
 * Displays the value provided with no manipulation
 * The value is centered and default styles
 */
var _default = exports["default"] = function _default(settings) {
  return function (_ref) {
    var value = _ref.value,
      row = _ref.row;
    var noValue = false;
    if ((0, _isNil2["default"])(value)) {
      noValue = true;
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: row,
      className: _style["default"].container
    }, !noValue ? /*#__PURE__*/_react["default"].createElement("div", null, "".concat(settings.prefix).concat(value).concat(settings.suffix)) : /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-center"
    }));
  };
};